(() => {
  'use strict';

  const selector = '[data-xifun-category-gateway]';
  const controllers = new Map();

  const init = (scope = document) => {
    const sections = scope.matches?.(selector) ? [scope] : [...scope.querySelectorAll(selector)];
    sections.forEach((section) => {
      if (controllers.has(section)) return;
      const items = [...section.querySelectorAll('[data-xifun-reveal]')];
      if (section.dataset.animate !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        controllers.set(section, null);
        return;
      }
      section.classList.add('is-enhanced');
      const observer = new IntersectionObserver(([entry]) => {
        if (!entry?.isIntersecting) return;
        items.forEach((item) => item.classList.add('is-visible'));
        observer.disconnect();
      }, { rootMargin: '120px 0px', threshold: 0.04 });
      observer.observe(section);
      const fallback = window.setTimeout(() => items.forEach((item) => item.classList.add('is-visible')), 700);
      controllers.set(section, { disconnect: () => { window.clearTimeout(fallback); observer.disconnect(); } });
    });
  };

  const destroy = (section) => {
    controllers.get(section)?.disconnect();
    controllers.delete(section);
  };

  if (!window.__xifunCategoryGatewayLoaded) {
    window.__xifunCategoryGatewayLoaded = true;
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
    window.addEventListener('pageshow', () => init());
  }

  init();
})();
